export class Modal {
  /**
   *
   * @param {string} [modalClass=g-modal]
   */
  constructor(modalClass = 'g-modal') {
    this.activeModal = 'js-active';
    this.activeContent = 'js-content-active';
    this.noScroll = 'no-scroll';

    this.scrollWidth = this.getScrollWidth();

    this.modal = document.querySelectorAll(`.${modalClass}`);
    this.modalsOpen = document.querySelectorAll('.js-modal');
    this.closeModalButton = document.querySelectorAll(`.g-modal__close`);
    this.body = document.querySelector('body');
    this.header = document.querySelector('header');
  }

  init() {
    if (this.modalsOpen.length) {
      this.clickModalHandler();
    }
    this.closeModal();
    window.addEventListener('resize', () => {
      this.scrollWidth = this.getScrollWidth();
    });
    return this;
  }

  closeModalHandler() {
    this.modal.forEach((item) => item.classList.remove(this.activeModal));
    const element = document.querySelector(`.${this.activeContent}`);
    element && element.classList.remove(this.activeContent);
    this.body.classList.remove(this.noScroll);
    if (this.body.style.paddingRight) {
      this.body.style.paddingRight = null;
      this.header.style.width = null;
    }
  }

  closeModal() {
    this.closeModalButtonHandler();
    this.modal.forEach((item) => {
      item.addEventListener('click', ({ target }) => {
        if (target === item) this.closeModalHandler();
      });
    });
  }

  getScrollWidth() {
    let div = document.createElement('div');
    div.style.overflowY = 'scroll';
    div.style.width = '50px';
    div.style.height = '50px';
    // мы должны вставить элемент в документ, иначе размеры будут равны 0
    document.body.append(div);
    let scrollWidth = div.offsetWidth - div.clientWidth;
    div.remove();
    return scrollWidth;
  }

  closeModalButtonHandler() {
    this.closeModalButton?.forEach((item) => {
      item.addEventListener('click', () => this.closeModalHandler());
    });
  }

  clickModalHandler() {
    this.modalsOpen.forEach((item) => {
      item.addEventListener('click', ({ target }) => {
        this.openModal(target);
      });
    });
  }

  openModal(target = null) {
    let dataId = null;

    if (target) {
      dataId = target.dataset.modal || this.findParentDataAttr(target);
    }

    this.modal.forEach((item) => {
      if (dataId) {
        const children = item.querySelector('.g-modal__container').querySelector(`[data-key=${dataId}]`);
        children && item.classList.add(this.activeModal);
        return;
      }

      item.classList.add(this.activeModal);
    });

    this.body.classList.add(this.noScroll);

    if (this.scrollWidth) {
      this.body.style.paddingRight = `${this.scrollWidth}px`;
      this.header.style.width = `calc(100% - ${this.scrollWidth}px)`;
    }

    if (dataId) this.openModalContentHandler(dataId);
  }

  openModalContentHandler(id) {
    document.querySelector(`[data-key="${id}"]`).classList.add(this.activeContent);
  }

  findParentDataAttr(el) {
    while (el.parentNode) {
      el = el.parentNode;
      if (el.dataset.modal) return el.dataset.modal;
    }
    return null;
  }
}

new Modal().init();
